{
  "groups": {
    "main": "Main",
    "config": "Configuration",
    "groupOverview": "Overview",
    "groupWorking": "Work",
    "groupAutomation": "Automation",
    "groupInfrastructure": "Infrastructure",
    "groupSettings": "Settings"
  },
  "items": {
    "buddy": "Buddy",
    "dashboard": "Dashboard",
    "health": "Health",
    "werkstatt": "Workshop",
    "chat": "Chat",
    "agents": "Agents",
    "projects": "Projects",
    "projectSettings": "Project Settings",
    "media": "Media",
    "vault": "Vault",
    "admin": "Admin",
    "communication": "Communication",
    "teamchat": "Team Chat",
    "vms": "VMs",
    "containers": "Containers",
    "butler": "Butler",
    "llm": "LLM",
    "mcp": "MCP",
    "skills": "Skills",
    "credentials": "Credentials",
    "system": "System",
    "users": "Users",
    "plugins": "Plugins",
    "extensions": "Extensions",
    "zahnfee": "Zahnfee",
    "federation": "Federation",
    "streaming": "Streaming",
    "datamining": "Datamining",
    "memory": "Memory",
    "jarvisMemory": "Jarvis memory",
    "wiki": "Wiki",
    "help": "Help",
    "modules": "Modules"
  },
  "apps_menu": "Apps",
  "sidebar": {
    "show": "Show sidebar",
    "hide": "Hide sidebar"
  },
  "online": "Online",
  "help_button": "Open page help",
  "help_label": "Help",
  "update": {
    "available": "Update available — click to update",
    "force": "Force update / rebuild",
    "modules": "{{count}} module update(s) available — go to module management",
    "modal_title": "System update",
    "confirm_question": "Update now?",
    "confirm_question_force": "Force update?",
    "confirm_hint": "The server will restart and be unreachable for 1-2 minutes.",
    "confirm_hint_force": "You are already on the latest version. Rebuild + restart anyway? Server unreachable for 1-2 minutes.",
    "confirm_button": "Start update",
    "starting": "Starting update…",
    "in_progress": "Update running…",
    "done": "Update complete — new version: {{commit}}",
    "failed": "Update failed: {{error}}",
    "log_title": "Live log",
    "log_empty": "No output yet…",
    "log_disconnected": "Server unreachable — waiting for restart…",
    "close": "Close",
    "stale_hint": "A newer version is running on the server. Reload to see all new features.",
    "reload": "Reload"
  },
  "restart": {
    "button": "Restart service",
    "modal_title": "Service restart",
    "confirm_question": "Restart backend now?",
    "confirm_hint": "After restart, freshly installed/removed plugins take full effect. Backend is unreachable for ~5-10 seconds.",
    "confirm_button": "Restart",
    "starting": "Starting restart…",
    "in_progress": "Backend restarting…",
    "done": "Service is back up.",
    "failed": "Restart failed: {{error}}",
    "close": "Close",
    "now": "Restart now"
  }
}
